import { Link } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { useUser } from "@clerk/react";
import { Ajustes } from "@/components/casca/Ajustes";
import { Aviso, Cartao } from "@/components/casca/formulario";
import { Aparencia } from "@/components/configuracoes/Aparencia";
import { BotaoSair } from "@/components/configuracoes/BotaoSair";
import { Icone } from "@/components/Icone";
import { configuracoesQuery } from "../consultas";

/**
 * O que é da PESSOA e do navegador dela — não da clínica. Nome e e-mail vêm do
 * Clerk que já está no navegador; do servidor, só o papel e o nome da clínica.
 */
export function Configuracoes() {
  const { data } = useSuspenseQuery(configuracoesQuery());
  const { user } = useUser();
  const { ehAdmin, donoDaPlataforma: dono } = data;

  return (
    <Ajustes titulo="Minha conta" descricao="Sua conta e a aparência do painel, só para você.">
      <div className="flex flex-col gap-5">
        <Cartao>
          <p className="rotulo mb-1.5">Conta</p>
          <h2 className="text-base font-bold text-[var(--color-tinta)]">
            {user?.fullName || user?.firstName || "Você"}
          </h2>
          <p className="mt-0.5 text-[13.5px] text-[var(--color-suave)]">{user?.primaryEmailAddress?.emailAddress}</p>
          <p className="mt-3 text-[13.5px] text-[var(--color-suave)]">
            Na <strong className="text-[var(--color-tinta)]">{data.clinica}</strong> você é{" "}
            <strong className="text-[var(--color-tinta)]">{ehAdmin ? "administrador" : "equipe"}</strong>
            {ehAdmin ? " — vê e edita tudo desta clínica." : " — vê o dia a dia; o administrador libera o resto."}
          </p>
          {dono && (
            <div className="mt-3">
              <Aviso tom="info">
                Você também é dono da plataforma: vê e administra todas as clínicas em{" "}
                <Link to="/sistema" className="font-semibold text-[var(--color-marca)] hover:underline">
                  Sistema
                </Link>
                .
              </Aviso>
            </div>
          )}
          <div className="mt-4">
            <BotaoSair />
          </div>
        </Cartao>

        <Cartao>
          <p className="rotulo mb-1.5">Aparência</p>
          <p className="mb-3 text-[13.5px] text-[var(--color-suave)]">
            Vale só para você, neste navegador. Enquanto você não mexer na chave, o painel segue o tema do aparelho.
          </p>
          <Aparencia />
        </Cartao>

        {ehAdmin && (
          <Cartao>
            <p className="rotulo mb-1.5">Bancada de teste</p>
            <h2 className="text-base font-bold text-[var(--color-tinta)]">Conversar com o assistente sem gastar WhatsApp</h2>
            <p className="mt-0.5 mb-3 text-[13.5px] leading-relaxed text-[var(--color-suave)]">
              A bancada fala com o modelo de verdade, na sua conta, usando o cadastro e a constituição desta
              clínica. Nada é enviado para ninguém — serve para conferir o que ele responde antes de o número
              estar no ar.
            </p>
            <Link
              to="/sandbox"
              className="flex h-9 w-fit items-center gap-1.5 rounded-full bg-[var(--color-cartao)] px-4 text-[13px] font-semibold text-[var(--color-tinta)] shadow-botao transition-colors hover:bg-[var(--color-painel)]"
            >
              <Icone nome="bancada" className="h-4 w-4" />
              Abrir a bancada
            </Link>
          </Cartao>
        )}
      </div>
    </Ajustes>
  );
}
